import type Features from '@modules/store/common/types/Features.entity';
import type FeaturesState from '@modules/store/common/types/FeaturesState.entity';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<FeaturesState> = {
  setLoading: (state, payload: boolean) => {
    state.loading = payload;
  },
  setFeatures: (state, payload: Features) => {
    state.features = payload;
  },
};
